module.exports = __webpack_public_path__ + "media/images/team-bd47baccfb79bf33849287275e880048.jpg";